import { get, deleteRequest, post, patch } from 'utils/api';

export const getOcpiPartnerPricing = (data) => {
  return get(`/ocpiPartnerTariff`, data);
};

export const addOcpiPartnerPricing = (data) => {
  return post(`/ocpiPartnerTariff`, data);
};

export const updateOcpiPartnerPricing = (data) => {
  const id = data.id;
  delete data['id'];
  return patch(`/ocpiPartnerTariff/${id}`, data);
};

export const deleteOcpiPartnerPricing = (id) => {
  return deleteRequest(`/ocpiPartnerTariff/${id}`);
};

export const getOcpiPartnerPricingById = (id) => {
  return get(`/ocpiPartnerTariff/${id}`);
};

export const ocpiPartnerPricing = {
  getOcpiPartnerPricing,
  addOcpiPartnerPricing,
  updateOcpiPartnerPricing,
  deleteOcpiPartnerPricing,
  getOcpiPartnerPricingById,
};
